import React from "react";
import { Input } from "@/components/ui/input";
import { Search, Mail, Filter } from "lucide-react";
import { EstablishmentMultiSelect } from "@/components/dashboard/EstablishmentMultiSelect";
import { useFilterOptions } from "@/hooks/useFilterOptions";
import { useDemoMode } from "@/contexts/DemoModeContext";
import { maskGeneratorName } from "@/utils/demoMode";

interface UserFiltersProps {
  nameFilter: string;
  setNameFilter: (value: string) => void;
  emailFilter: string;
  setEmailFilter: (value: string) => void;
  roleFilter: string;
  setRoleFilter: (value: string) => void;
  generatorFilter: string[];
  setGeneratorFilter: (value: string[]) => void;
  filteredCount: number;
  totalCount: number;
}

export const UserFilters: React.FC<UserFiltersProps> = ({
  nameFilter,
  setNameFilter,
  emailFilter,
  setEmailFilter,
  generatorFilter,
  setGeneratorFilter,
  filteredCount,
  totalCount,
}) => {
  const { establishments } = useFilterOptions();

  const { isDemoMode } = useDemoMode();

  const generatorOptions = establishments.map((est) => ({
    value: est.id_new_engine_generators,
    label: maskGeneratorName(est.establishment_name, isDemoMode),
  }));

  return (
    <div className="flex flex-col lg:flex-row lg:items-center justify-between mb-6 gap-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 flex-1 min-w-0 ">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
          <Input
            placeholder="Buscar por nome..."
            value={nameFilter}
            onChange={(e) => setNameFilter(e.target.value)}
            className="pl-10"
          />
        </div>

        <div className="relative">
          <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
          <Input
            placeholder="Buscar por email..."
            value={emailFilter}
            onChange={(e) => setEmailFilter(e.target.value)}
            className="pl-10"
          />
        </div>

        <div className="space-y-2">
          <EstablishmentMultiSelect
            options={generatorOptions}
            value={generatorFilter}
            onChange={(values) => {
              setGeneratorFilter(values);
            }}
            placeholder="Todos os geradores"
            aria-label="Filtro de gerador"
          />
        </div>
      </div>

      <div className="flex items-center gap-2 lg:ml-4 justify-center lg:justify-start">
        <Filter className="w-4 h-4 text-gray-500" />
        <span className="text-sm text-gray-500">
          {filteredCount} de {totalCount} usuários
        </span>
      </div>
    </div>
  );
};
